<template>
		<div class="navs l_o_btm">
      <router-link to="/opera/">
        <div class="nav">
          <i class="iconfont icon-shouye " :class="{active:sta=='1','icon-shouyeH': sta=='1',}"></i>
          <p>{{$t('footNav_home')}}</p>
        </div>
      </router-link>
      <router-link to="/opera/info">
        <div class="nav">
          <i class="iconfont icon-xiaoxi2" :class="{active:sta=='2','icon-xiaoxiH': sta=='2',}"></i>
          <p>{{$t('footNav_info')}}</p>
          <div class="message" v-if='infoCount>0'>{{infoCount}}</div>
        </div>
      </router-link>
      <router-link to="/opera/center">
        <div class="nav">
          <i class="iconfont icon-gerenzhongxin" :class="{active:sta=='3','icon-gerenzhongxinH': sta=='3'}"></i>
          <p>
            <span>{{$t('footNav_center')}}</span>
          </p>
        </div>
      </router-link>
		</div>
</template>
<script>
export default {
  props: ["sta"],
  data() {
    return {
      infoCount: 0,
      isHuanQiu: false,
    };
  },
  mounted() {
    this.getData();
    this.getGlobalPermission()
  },
  methods: {
    getGlobalPermission(){
      const self = this
      this.$http.get("/mobilepmsapi/sysOptions/findOptionByOpen").then(res => {
        if (res.data.result == 0) {
          let retVal = res.data.retVal || {};
          this.hideAdvertise = !!retVal.hideAdvertise;
          localStorage.setItem('CustomersOpen', retVal.CustomersOpen ? "yes" : 'no') // 客源范围的日期删选
          localStorage.setItem('OrderCountForRoomNumber', retVal.OrderCountForRoomNumber ? "yes" : 'no') // 客源范围的日期删选
          localStorage.setItem('rateChange',retVal.rateChange ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isAdmin', retVal.isAdmin ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isJingJiang', retVal.isJingJiang ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isHuanQiu', retVal.isHuanQiu ? "yes" : 'no') // 判断用户是否是 ADMIN
          localStorage.setItem('isHideDashboard', retVal.isHideDashboard ? "yes" : 'no') // 判断opera用户是否隐藏首页图表
          localStorage.setItem('isOpenReport1ArgPyear',retVal.isOpenReport1ArgPyear ? true : false) // 是否开启自定义选择年份功能
          this.isHuanQiu = retVal.isHuanQiu
          if(retVal.isHuanQiu){
            self.$router.replace('/opera/indexHuanQiu')
          }
        }
      });
    },
    getData() {
      if (localStorage.getItem("JWT_TOKEN")) {
        this.$http
          .get("/mobilepmsapi/message/unreadMessageNumber")
          .then(res => {
            this.infoCount = res.data.retVal;
            if (this.$isApp) {
              plus.runtime.setBadgeNumber(this.infoCount);
              if (plus.os.name == "iOS") {
                var GeTuiSdk = plus.ios.importClass("GeTuiSdk");
                GeTuiSdk.setBadge(this.infoCount);
              }
            }
          });
      }
    }
  }
};
</script>
<style lang='less' scoped>
.navs {
  box-shadow: 0 -0.0533rem 0.5333rem rgba(0, 0, 0, 0.1);
  position: fixed;
  z-index: 1000;
  bottom: 0px;
  width: 100%;
  height: 1.1733rem;
  background-color: #fff;
  .nav {
    float: left;
    width: 33.3%;

    &.isHuanQiu{
      width: 50%;
    }

    text-align: center;
    position: relative;
    line-height: normal;
    .iconfont {
      margin-top: 0.1333rem;
      font-size: 0.5333rem;
      color: #b1b1b1;
      display: inline-block;
      &.active {
        color: #f6a623;
      }
    }
    p {
      height: 0.5333rem;
      font-size: 0.32rem;
      color: #999;
      -webkit-transform-origin-x: center;
      -webkit-transform: scale(0.9);
      transform: scale(0.9);
    }
    .message {
      background: red;
      width: 0.4rem;
      height: 0.4rem;
      line-height: 0.4rem;
      position: absolute;
      top: 0;
      right: 1.2rem;
      color: #fff;
      border-radius: 50%;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// footNav.vue?60034f72